import {useI18n} from 'i18n/I18nContext'
import React from 'react'
import ExtensionIcon from '@mui/icons-material/Extension'
import {useEventAddons} from 'organization/Event/Addons/EventAddonsProvider'

export const EventAddons = () => {
  const {t} = useI18n()
  const {addons, buyAddon} = useEventAddons()

  return (
    <>
      {addons.map((addon) => (
        <div key={addon.id} className="col-xxl-4 col-xl-4 col-lg-4 col-md-4">
          <div className="event__venue-card mb-20">
            <div className="event__venue-inner">
              <div className="event__venue-content">
                <div className="event__venue-meta">
                  <div className="news__meta-status">
                    <span>
                      <i>
                        <ExtensionIcon />
                      </i>
                    </span>
                    <span>{addon.name}</span>
                  </div>
                </div>
                <h4 className="event__venue-title">
                  {t('orgAddon.pricePrefix')} {addon.price} €
                </h4>
              </div>
              <div className="event__venue-thumb">
                <div className="pricing__item mb-30">
                  <div className="pricing__item-header">
                    <div>
                      <span className="pricing__item-title">{addon.name}</span>
                    </div>
                  </div>
                  <div className="pricing__item-content">
                    <ul>
                      <li>
                        <i className="flaticon-comment"></i> {addon.description}
                      </li>
                    </ul>
                  </div>
                  <div className="pricing__btn-wrap">
                    {!addon.is_purchased && addon.active && (
                      <button
                        className="input__btn w-100"
                        onClick={() => buyAddon(addon.type)}
                      >
                        {t('orgAddon.buyNow')}
                      </button>
                    )}

                    {!addon.is_purchased && !addon.active && (
                      <button className="disableBtnStyle w-100">
                        {t('orgAddon.onRequest')}
                      </button>
                    )}

                    {addon.is_purchased && (
                      <button className="input__btn w-100">
                        {t('orgAddon.purchased')}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  )
}
